import {Directive, ElementRef, EventEmitter, HostListener, Input, Output} from '@angular/core';

@Directive({
    selector: '[mouseWheel]',
    standalone: false
})
export class MouseWheelDirective {
  // @Input() public MouseWheelasdasd = [];
  @Output() public MouseWheelOnChange = new EventEmitter<object>();

  constructor(private _el: ElementRef) {}

  @HostListener('mousewheel', ['$event'])
  scroll(event) {
    event.preventDefault();
    const wheelDelta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));
    if (wheelDelta !== 0) {
      this.MouseWheelOnChange.emit({
        wheelDelta: wheelDelta,
        layerX: event.layerX,
        layerY: event.layerY,
      });
    }
  }
}
